var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/** Extract a character offset from a JSON.parse SyntaxError message. */
export function extractJsonErrorOffset(message, sourceLength) {
    var e_1, _a;
    var patterns = [/at position\s+(\d+)/i, /at offset\s+(\d+)/i, /column\s+(\d+)/i];
    try {
        for (var patterns_1 = __values(patterns), patterns_1_1 = patterns_1.next(); !patterns_1_1.done; patterns_1_1 = patterns_1.next()) {
            var re = patterns_1_1.value;
            var m = message.match(re);
            if (!m)
                continue;
            if (re.source.includes('column') && !/position|offset/i.test(message))
                continue;
            var n = Number(m[1]);
            if (Number.isFinite(n) && n >= 0)
                return Math.min(n, Math.max(0, sourceLength));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (patterns_1_1 && !patterns_1_1.done && (_a = patterns_1.return)) _a.call(patterns_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return null;
}
function offsetFromLineColumn(source, line, column) {
    var lines = source.split(/\r?\n/);
    var offset = 0;
    for (var i = 0; i < lines.length; i++) {
        if (i + 1 === line) {
            return offset + Math.max(0, Math.min(column - 1, lines[i].length));
        }
        offset += lines[i].length + 1;
    }
    return Math.max(0, source.length - 1);
}
/** Map a parse error + source string to line/column and a caret snippet. */
export function locateJsonError(source, err) {
    var _a;
    var message = err instanceof Error ? err.message : String(err);
    var lines = source.split(/\r?\n/);
    var offset = extractJsonErrorOffset(message, source.length);
    var lc = message.match(/\(line\s+(\d+)\s+column\s+(\d+)\)/i);
    if (offset == null && lc) {
        offset = offsetFromLineColumn(source, Number(lc[1]), Number(lc[2]));
    }
    if (offset == null) {
        offset = Math.max(0, source.length - 1);
    }
    var line = 1;
    var column = 1;
    var acc = 0;
    for (var i = 0; i < lines.length; i++) {
        var len = lines[i].length;
        var lineEnd = acc + len;
        if (offset <= lineEnd || i === lines.length - 1) {
            line = i + 1;
            column = Math.max(1, offset - acc + 1);
            break;
        }
        acc = lineEnd + 1;
    }
    var lineText = (_a = lines[line - 1]) !== null && _a !== void 0 ? _a : '';
    var caretPad = Math.max(0, column - 1);
    var marker = "".concat(' '.repeat(caretPad), "^");
    var snippet = ["  ".concat(line, " | ").concat(lineText), "  ".concat(' '.repeat(String(line).length), " | ").concat(marker)].join('\n');
    return { offset: offset, line: line, column: column, lineText: lineText, snippet: snippet };
}
/** Format a JSON.parse failure with line, column, reason, and a caret snippet. */
export function formatJsonParseError(source, err) {
    var message = err instanceof Error ? err.message : String(err);
    var loc = locateJsonError(source, err);
    var reason = message
        .replace(/\s*in JSON at position \d+/i, '')
        .replace(/\s*\(line \d+ column \d+\)/i, '')
        .trim();
    return "JSON parse error at line ".concat(loc.line, ", column ").concat(loc.column, ": ").concat(reason, "\n") + loc.snippet;
}
